import { istGueltigeEFNEingabe } from './listenEingabe';


// Actions
export const ADD_TEILNAHME_CHANGE_EFN = 'ADD_TEILNAHME_CHANGE_EFN'
export const ADD_TEILNAHME_SANITIZE_EFNS = 'ADD_TEILNAHME_SANITIZE_EFNS'
export const ADD_TEILNAHME_REMOVE_UNGUELTIGE_EFNS = 'ADD_TEILNAHME_REMOVE_UNGUELTIGE_EFNS'
export const ADD_TEILNAHME_CHANGE_TEILNAHMEDATUM = 'ADD_TEILNAHME_CHANGE_TEILNAHMEDATUM'
export const ADD_TEILNAHME_CHANGE_PUNKTE_REFERENT = 'ADD_TEILNAHME_CHANGE_PUNKTE_REFERENT'
export const ADD_TEILNAHME_TOGGLE_PUNKTE_BASIS = 'ADD_TEILNAHME_TOGGLE_PUNKTE_BASIS'
export const ADD_TEILNAHME_TOGGLE_PUNKTE_LERNERFOLG = 'ADD_TEILNAHME_TOGGLE_PUNKTE_LERNERFOLG'
export const ADD_TEILNAHME_REF_PUNKTE_INCREASE = 'ADD_TEILNAHME_REF_PUNKTE_INCREASE'
export const ADD_TEILNAHME_REF_PUNKTE_DECREASE = 'ADD_TEILNAHME_REF_PUNKTE_DECREASE'
export const ADD_TEILNAHME_REF_PUNKTE_CHANGE = 'ADD_TEILNAHME_REF_PUNKTE_CHANGEE'
export const ADD_TEILNAHME_HINZUGUEGEN = 'ADD_TEILNAHME_HINZUGUEGEN'
export const ADD_TEILNAHME_EFN_QRCODE_SCANNED = 'ADD_TEILNAHME_EFN_QRCODE_SCANNED'
export const ADD_TEILNAHME_QR_READER_TOGGLE_MULTISCAN_MODE = 'ADD_TEILNAHME_QRCODE_TOGGLE_MULTISCAN_MODE'


export const PUNKTEMELDUNG_REMOVE_TEILNEHMER = 'PUNKTEMELDUNG_REMOVE_TEILNEHMER'
export const PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_BASIS = 'PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_BASIS'
export const PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_LERNERFOLG = 'PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_LERNERFOLG'
export const PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_INCREASE = 'PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_INCREASE'
export const PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_DECREASE = 'PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_DECREASE'
export const PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_CHANGE = 'PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_CHANGE'
export const PUNKTEMELDUNG_TEILNEHMER_CHANGE_TEILNAHMEDATUM = 'PUNKTEMELDUNG_TEILNEHMER_CHANGE_TEILNAHMEDATUM'

export const PUNKTEMELDUNG_BESCHRIFTUNG_SET = 'PUNKTEMELDUNG_BESCHRIFTUNG_SET'
export const PUNKTEMELDUNG_BESCHRIFTUNG_REMOVE = 'PUNKTEMELDUNG_BESCHRIFTUNG_REMOVE'
export const PUNKTEMELDUNG_BESCHRIFTUNGEN_CLEAR = 'PUNKTEMELDUNG_BESCHRIFTUNGEN_CLEAR'
export const PUNKTEMELDUNG_BESCHRIFTUNG_AUS_SCAN = 'PUNKTEMELDUNG_BESCHRIFTUNG_AUS_SCAN'
export const PUNKTEMELDUNG_BESCHRIFTUNG_SCAN_VERWERFEN = 'PUNKTEMELDUNG_BESCHRIFTUNG_SCAN_VERWERFEN'

// Action creator
export const addTeilnahmeSetEFN = (vnr, efn) => {
	return { type: ADD_TEILNAHME_CHANGE_EFN, payload : efn, vnr }
}
export const addTeilnahmeSanitizeEFNs = (vnr) => {
	return { type: ADD_TEILNAHME_SANITIZE_EFNS, vnr }
}
export const addTeilnahmeRemoveUngueltigeEFNs = (vnr) => {
	return { type: ADD_TEILNAHME_REMOVE_UNGUELTIGE_EFNS, vnr }
}
export const addTeilnahmeQRReaderToggleMultiscanMode = () => {
	return { type: ADD_TEILNAHME_QR_READER_TOGGLE_MULTISCAN_MODE }
}
/**
 * Die Beschriftung reist als eigenes Action-Feld und nicht im addTeilnahmeState mit: das
 * Teilnahme-Objekt geht so, wie es im Store liegt, an die Veranstalter-API - dort hat ein
 * Name nichts verloren. Siehe beschriftungenReducer und peekTeilnahmeToSend.
 */
export const addTeilnahmeQrCodeEFNScanned = (vnr, qrScanResult, addTeilnahmeState, beschriftung) => {
	return { type: ADD_TEILNAHME_EFN_QRCODE_SCANNED, payload : qrScanResult, vnr, addTeilnahmeState, beschriftung }
}
export const addTeilnahmeTogglePunkteBasis = (vnr) => {
	return { type: ADD_TEILNAHME_TOGGLE_PUNKTE_BASIS, vnr }
}
export const addTeilnahmeTogglePunkteLernerfolg = (vnr) => {
	return { type: ADD_TEILNAHME_TOGGLE_PUNKTE_LERNERFOLG, vnr }
}
export const addTeilnahmeRefPunkteInc = (vnr) => {
	return { type: ADD_TEILNAHME_REF_PUNKTE_INCREASE, vnr }
}
export const addTeilnahmeRefPunkteDec = (vnr) => {
	return { type: ADD_TEILNAHME_REF_PUNKTE_DECREASE, vnr }
}
export const addTeilnahmeRefPunkteSet = (vnr, refPunkte) => {
	return { type: ADD_TEILNAHME_REF_PUNKTE_CHANGE, payload: refPunkte, vnr }
}
export const teilnehmerRefPunkteSet = (vnr, efn, refPunkte) => {
	return { type: PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_CHANGE, vnr, efn, refPunkte }
}
export const teilnehmerRefPunkteInc = (vnr, efn) => {
	return { type: PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_INCREASE, vnr, efn }
}
export const teilnehmerRefPunkteDec = (vnr, efn) => {
	return { type: PUNKTEMELDUNG_TEILNEHMER_REF_PUNKTE_DECREASE, vnr, efn }
}
/**
 * Liest den Eingabetext frisch aus dem Store, statt ihn sich von der Komponente reichen zu
 * lassen. Zwei Gruende, beide real:
 *
 * 1. Ein Handscanner mit CR+LF schickt zwei Enter-Ereignisse. Kaeme der Text aus den Props,
 *    haette das zweite moeglicherweise noch den alten Stand - und wuerde die gerade
 *    verbrauchte Restliste zurueck ins Feld schreiben. Hier liegt nach dem ersten dispatch
 *    schon der neue Stand, die Wache greift, es passiert nichts.
 * 2. Vorher schrieb dieser Creator `addedTimestamp` direkt in das uebergebene Objekt - und das
 *    ist der Store-State selbst (VeranstaltungPage reicht addTeilnahme[vnr] durch). Der
 *    Zeitstempel gehoert in die Action, nicht in fremdes Gedaechtnis.
 *
 * Die Action traegt den unveraenderten Eingabetext und einen Schnappschuss der
 * Teilnahmeparameter - aber weder Beschriftungen noch ein fertig geparstes Listenergebnis.
 * Der Eingabetext bleibt die eine Quelle; jeder Reducer leitet mit parseListe daraus ab.
 */
export const addTeilnehmer = (vnr) => (dispatch, getState) => {
	const stand = getState().punkteMeldung.addTeilnahme[vnr];
	if(!stand || !istGueltigeEFNEingabe(stand.efn)) return;
	dispatch({
		type: ADD_TEILNAHME_HINZUGUEGEN,
		vnr,
		eingabe: stand.efn,
		teilnahmeVorlage: {
			punkte_basis_flag: stand.punkte_basis_flag,
			punkte_lernerfolg_flag: stand.punkte_lernerfolg_flag,
			punkte_referent: stand.punkte_referent,
			teilnahmedatum: stand.teilnahmedatum
		},
		addedTimestamp: Date.now()
	})
}
export const changeTeilnahmedatum = (vnr, teilnahmedatum) => {
	return { type: ADD_TEILNAHME_CHANGE_TEILNAHMEDATUM, vnr, teilnahmedatum }
}
export const teilnehmerChangeTeilnahmedatum = (vnr, efn, teilnahmedatum) => {
	return { type: PUNKTEMELDUNG_TEILNEHMER_CHANGE_TEILNAHMEDATUM, vnr, efn, teilnahmedatum }
}
export const removeTeilnehmer = (vnr, efn) => {
	return { type: PUNKTEMELDUNG_REMOVE_TEILNEHMER, vnr, efn }
}
export const toggleTeilnehmerPunkteBasis = (vnr, efn) => {
	return { type: PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_BASIS, vnr, efn }
}
export const toggleTeilnehmerPunkteLernerfolg = (vnr, efn) => {
	return { type: PUNKTEMELDUNG_TEILNEHMER_TOGGLE_PUNKTE_LERNERFOLG, vnr, efn }
}

/**
 * Beschriftungen zu EFNs - siehe beschriftungenReducer. Sie bleiben im Browser und werden
 * nie mitgemeldet.
 */
export const setBeschriftung = (vnr, efn, text) => {
	return { type: PUNKTEMELDUNG_BESCHRIFTUNG_SET, vnr, efn, beschriftung: { text } }
}
export const removeBeschriftung = (vnr, efn) => {
	return { type: PUNKTEMELDUNG_BESCHRIFTUNG_REMOVE, vnr, efn }
}
export const clearBeschriftungen = (vnr) => {
	return { type: PUNKTEMELDUNG_BESCHRIFTUNGEN_CLEAR, vnr }
}

/** Aus einem Barcode: fuellt eine leere Beschriftung, merkt sich sonst den Widerspruch. */
export const beschriftungAusScan = (vnr, efn, beschriftung) => {
	return { type: PUNKTEMELDUNG_BESCHRIFTUNG_AUS_SCAN, vnr, efn, beschriftung }
}
/** Der gemerkte abweichende Scan wird verworfen, die vorhandene Beschriftung bleibt. */
export const verwerfeAbweichendenScan = (vnr, efn) => {
	return { type: PUNKTEMELDUNG_BESCHRIFTUNG_SCAN_VERWERFEN, vnr, efn }
}
